import React from "react";
import FileInputPreview from "../../ui/FileInputPreview";




// Re-evaluating: In PagesManager.jsx, the form handles "selectedPage".
// If I select 'about', fetchPage('about') runs. content is loaded. `reset(content)` runs on the ONE useForm hook in PagesManager.
// So, I should just render the About fields INSIDE PagesManager when selectedPage === 'about'.
// OR extract the sub-components but pass `register`.
// Let's create AboutManager as a functional component that accepts { register, errors } and renders the fields.

const AboutManager = ({ register, errors, existingImageUrl }) => {
  return (
    <div className="grid grid-cols-1 gap-6">
      {/* Introduction Section */}
      <div className="bg-gray-50 dark:bg-meta-4/30 p-4 rounded-lg">
        <h3 className="text-lg font-medium mb-4 text-black dark:text-white">
          Introduction & Video
        </h3>

        <div className="mb-4">
          <label className="mb-2.5 block font-medium text-black dark:text-white">
             Section Title
          </label>
          <input
            type="text"
            {...register("about_title")}
            placeholder="e.g. Meet Osama Ali..."
            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input"
          />
        </div>

        <div className="mb-4">
            <label className="mb-2.5 block font-medium text-black dark:text-white">
                Video URL (YouTube/Vimeo or Local Path)
            </label>
            <input
            type="text"
            {...register("video_url")}
            placeholder="/data/intro-video.mp4"
            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input"
            />
            <p className="text-xs text-gray-500 mt-1">If using a local file, upload it manually or provide the path. Currently supporting URL strings.</p>
        </div>
      </div>

       {/* Bio Section */}
       <div className="bg-gray-50 dark:bg-meta-4/30 p-4 rounded-lg">
        <h3 className="text-lg font-medium mb-4 text-black dark:text-white">
          Biography & Details
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
                 <div className="mb-4">
                    <label className="mb-2.5 block font-medium text-black dark:text-white">
                        Quote / Tagline
                    </label>
                     <textarea
                        rows={3}
                        {...register("about_quote")}
                        placeholder="A designer knows..."
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input"
                    ></textarea>
                </div>
                <div className="mb-4">
                    <label className="mb-2.5 block font-medium text-black dark:text-white">
                        Full Biography
                    </label>
                     <textarea
                        rows={6}
                        {...register("about_description")}
                        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input"
                    ></textarea>
                </div>
            </div>

             {/* Image & Counters */}
            <div>
                 <div className="mb-4">
                    <label className="mb-2.5 block font-medium text-black dark:text-white">
                        Portrait Image
                    </label>
                    <FileInputPreview
                        registerProps={register("about_image")}
                        existingImageUrl={existingImageUrl}
                        previewClassName="mb-3 h-20 w-20 rounded-lg object-cover border border-stroke dark:border-form-strokedark"
                        inputClassName="w-full cursor-pointer rounded-lg border-[1.5px] border-stroke bg-transparent font-medium outline-none transition file:mr-5 file:border-collapse file:cursor-pointer file:border-0 file:border-r file:border-solid file:border-stroke file:bg-whiter file:py-3 file:px-5 file:hover:bg-primary file:hover:bg-opacity-10 focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:file:border-form-strokedark dark:file:bg-white/30 dark:file:text-white"
                    />
                </div>

                <div className="grid grid-cols-3 gap-2">
                     <div>
                        <label className="mb-1 block text-sm font-medium text-black dark:text-white">
                            Years Exp.
                        </label>
                        <input
                            type="text"
                            {...register("experience_year")}
                            placeholder="01+"
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-2 px-3 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input"
                        />
                    </div>
                     <div>
                        <label className="mb-1 block text-sm font-medium text-black dark:text-white">
                            Certifications
                        </label>
                        <input
                            type="text"
                            {...register("completed_certifications")}
                            placeholder="05+"
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-2 px-3 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input"
                        />
                    </div>
                     <div>
                        <label className="mb-1 block text-sm font-medium text-black dark:text-white">
                            Companies
                        </label>
                        <input
                            type="text"
                            {...register("companies_worked")}
                            placeholder="01"
                            className="w-full rounded border-[1.5px] border-stroke bg-transparent py-2 px-3 font-medium outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input"
                        />
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default AboutManager;
